<template>
  <div class="tile-preview-container">
    <div class="tile-promo-display-selections-div">
      <div
        v-if="appsStore.app?.flags?.legacy_apple_editor && model.path_type !== 'interstitial'"
        class="tile-promo-display-selections-opt"
      >
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'desktopViewTab' }"
          @click="$emit('clickTab', 'desktopViewTab')"
        >
          iPad
        </button>
        <button
          class="tab"
          :class="{ active: viewTypeTab === 'mobilewebViewTab' }"
          @click="$emit('clickTab', 'mobilewebViewTab')"
        >
          iPhone
        </button>
      </div>
      <div class="tab-selector mr-4">
        <RfLiquidPreview
          v-model:userData="liquidContextStore.previewUserContext"
          :appId="appsStore.app?.id"
        />
        <RfLanguagePreview :model="model" :actions="actions" />
      </div>
    </div>
    <v-tabs-window :modelValue="viewTypeTab" class="h-full w-full cursor-not-allowed">
      <v-window-item
        id="desktopViewTab"
        :transition="false"
        :reverseTransition="false"
        class="h-full w-full overflow-auto"
        value="desktopViewTab"
      >
        <RfRetentionModal
          ref="ios_ipad"
          :model="model"
          :actions="previewActions"
          :deviceType="mobileViewType"
          :zoomStyle="zoomStyle"
          :isMobile="
            !appsStore.app?.flags?.legacy_apple_editor || model.path_type === 'interstitial'
          "
          :isNewDeviceEditor="!appsStore.app?.flags?.legacy_apple_editor"
        />
        <div class="ipadToggleView">
          <button @click="mobileView('ipadLandscape')">
            <v-icon color="#ccc">md:stay_current_landscape</v-icon>
          </button>
          <button @click="mobileView('ipadPortrait')">
            <v-icon color="#ccc">md:stay_current_portrait</v-icon>
          </button>
        </div>
      </v-window-item>
      <v-window-item
        id="mobilewebViewTab"
        :transition="false"
        :reverseTransition="false"
        class="h-full w-full overflow-auto"
        value="mobilewebViewTab"
      >
        <RfRetentionModal
          ref="ios_iphone"
          :model="model"
          isMobile
          :actions="previewActions"
          deviceType="mobileWeb"
        />
      </v-window-item>
    </v-tabs-window>
    <div v-if="viewTypeTab === 'desktopViewTab'" class="preview-control-buttons">
      <v-btn size="small" color="#f3f3f3" @click="zoomIn">+</v-btn>
      <v-btn class="reset-zoom-btn" size="small" color="#f3f3f3" @click="resetZoom">{{
        `${zoomValue * 100}%`
      }}</v-btn>
      <v-btn size="small" color="#f3f3f3" @click="zoomOut">-</v-btn>
    </div>
    <component :is="'style'" v-if="actions.rf_settings_custom_css">
      {{ actions.rf_settings_custom_css }}
    </component>
  </div>
</template>

<script>
import RfRetentionModal from "@/components/RfPathCreate/RfRetentionActions/RfRetentionModal.vue";
import ZoomPreviewMixin from "@/utils/ZoomPreviewMixin";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import CompositeImageSaver from "@/utils/CompositeImageSaver";
import RfLanguagePreview from "@/components/RfPathCreate/RfRetentionDevices/RfLanguagePreview.vue";
import { useAppsStore } from "@/pinia/appsStore";
import RfLiquidPreview from "./RfLiquidPreview.vue";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionDevicIos",
  components: { RfRetentionModal, RfLanguagePreview, RfLiquidPreview },
  mixins: [ZoomPreviewMixin, LanguagePreviewMixin],
  props: ["actions", "viewTypeTab", "model"],
  setup: () => ({ appsStore: useAppsStore(), liquidContextStore: useLiquidContextStore() }),
  data: () => ({ mobileViewType: "ipadLandscape" }),
  methods: {
    mobileView(viewMode) {
      this.mobileViewType = viewMode;
    },
    async fillModel(model) {
      if (!model.device_type) {
        model.device_type = this.model.device_type;
      }
      await CompositeImageSaver.fill(model, this.$refs, this.appsStore.app);
    },
  },
};
</script>
